import React, { useState, useEffect, useRef } from "react";
import { useJsApiLoader, Autocomplete } from "@react-google-maps/api";

const libraries = ["places"];

const AddSchedule = ({ setShowModal, onClose, onSubmit }) => {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyAbJIqSfbwgfz4NfYdcGQNEc-d01WeSKgw", // Replace with your API key
    libraries,
  });

  const [formData, setFormData] = useState({
    userId: "",
    driverId: "",
    charge: "0",
    currentLocationName: "",
    destinationLocationName: "",
    distance: "0",
    pickupTime: "",
    pickupCoords: null,
    destinationCoords: null,
  });

  const ethiopiaBounds = {
    north: 15.0,
    south: 3.4,
    east: 48.0,
    west: 33.0,
  };

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [shake, setShake] = useState(false);

  const pickupRef = useRef(null);
  const destinationRef = useRef(null);

  // Validate form fields
  const validateForm = () => {
    const newErrors = {};
    if (!formData.userId) newErrors.userId = "User phone is required";
    if (!formData.driverId) newErrors.driverId = "Driver ID is required";
    if (!formData.currentLocationName)
      newErrors.currentLocationName = "Pickup location is required";
    if (!formData.destinationLocationName)
      newErrors.destinationLocationName = "Destination is required";
    if (!formData.distance || formData.distance === "0")
      newErrors.distance = "Distance is required";
    if (!formData.charge || formData.charge === "0")
      newErrors.charge = "Charge is required";
    if (!formData.pickupTime) newErrors.pickupTime = "Pickup time is required";

    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      setShake(true);
      setTimeout(() => setShake(false), 500);
    }

    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: null }));
  };

  // Calculate distance and charge
  const calculateDistance = (pickupCoords, destinationCoords) => {
    if (!pickupCoords || !destinationCoords || !isLoaded) return;

    const service = new window.google.maps.DistanceMatrixService();
    service.getDistanceMatrix(
      {
        origins: [
          new window.google.maps.LatLng(pickupCoords.lat, pickupCoords.lng),
        ],
        destinations: [
          new window.google.maps.LatLng(
            destinationCoords.lat,
            destinationCoords.lng
          ),
        ],
        travelMode: window.google.maps.TravelMode.DRIVING,
      },
      (response, status) => {
        if (status === "OK") {
          const distanceValue =
            response.rows[0].elements[0].distance.value / 1000; // distance in km

          // Fare calculation: base 40 ETB + 30 ETB per km
          const charge = (40 + distanceValue * 30).toFixed(2);

          console.log(charge);

          setFormData((prev) => ({
            ...prev,
            distance: distanceValue.toFixed(2),
            charge,
          }));
        } else {
          setErrors({ submit: "Failed to calculate distance." });
        }
      }
    );
  };

  // Recalculate distance when coordinates change
  useEffect(() => {
    if (formData.pickupCoords && formData.destinationCoords) {
      calculateDistance(formData.pickupCoords, formData.destinationCoords);
    }
  }, [formData.pickupCoords, formData.destinationCoords, isLoaded]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setIsSubmitting(true);
    try {
      await onSubmit({
        ...formData,
        charge: parseFloat(formData.charge) || 0,
        pickupTime: new Date(formData.pickupTime).toISOString(),
      });

      // Reset form
      setFormData({
        userId: "",
        driverId: "",
        charge: "0",
        currentLocationName: "",
        destinationLocationName: "",
        distance: "0",
        pickupTime: "",
        pickupCoords: null,
        destinationCoords: null,
      });
      onClose();
    } catch (error) {
      setErrors({ submit: "Failed to create ride. Please try again." });
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!setShowModal) return null;
  if (!isLoaded)
    return <div className="text-center p-4">Loading Google Maps...</div>;

  return (
    <div
      className={`max-w-md mx-auto bg-white p-6 shadow-md rounded-xl ${
        shake ? "animate__animated animate__shakeX" : ""
      }`}
    >
      <h5 className="text-2xl font-bold mb-4">Book a Ride</h5>

      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="form-label fw-bold">User Phone</label>
          <input
            type="tel"
            className={`form-control ${errors.userId ? "is-invalid" : ""}`}
            name="userId"
            value={formData.userId}
            onChange={handleChange}
            required
            placeholder="Enter User Phone number"
          />
          {errors.userId && (
            <div className="invalid-feedback">{errors.userId}</div>
          )}
        </div>

        <div className="mb-3">
          <label className="form-label fw-bold">Pickup Location</label>
          <Autocomplete
            options={{
              bounds: ethiopiaBounds,
              strictBounds: false,
              componentRestrictions: { country: "et" },
              fields: ["formatted_address", "geometry"],
            }}
            onLoad={(autocomplete) => (pickupRef.current = autocomplete)}
            onPlaceChanged={() => {
              if (pickupRef.current) {
                const place = pickupRef.current.getPlace();

                if (!place || !place.geometry) {
                  console.warn("No place selected or place has no geometry.");
                  return;
                }
                // if (place.geometry) {
                setFormData((prev) => ({
                  ...prev,
                  currentLocationName: place.formatted_address,
                  pickupCoords: {
                    lat: place.geometry.location.lat(),
                    lng: place.geometry.location.lng(),
                  },
                }));
                // }
              }
            }}
            // options={autocompleteOptions} // <-- Restriction here
          >
            <input
              type="text"
              className={`form-control ${
                errors.currentLocationName ? "is-invalid" : ""
              }`}
              value={formData.currentLocationName}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  currentLocationName: e.target.value,
                }))
              }
              required
            />
          </Autocomplete>
          {errors.currentLocationName && (
            <div className="invalid-feedback">{errors.currentLocationName}</div>
          )}
        </div>

        <div className="mb-3">
          <label className="form-label fw-bold">Destination</label>
          <Autocomplete
            options={{
              bounds: ethiopiaBounds,
              strictBounds: false,
              componentRestrictions: { country: "et" },
              fields: ["formatted_address", "geometry"],
            }}
            onLoad={(autocomplete) => (destinationRef.current = autocomplete)}
            onPlaceChanged={() => {
              if (destinationRef.current) {
                const place = destinationRef.current.getPlace();
                if (place.geometry) {
                  setFormData((prev) => ({
                    ...prev,
                    destinationLocationName: place.formatted_address,
                    destinationCoords: {
                      lat: place.geometry.location.lat(),
                      lng: place.geometry.location.lng(),
                    },
                  }));
                }
              }
            }}
          >
            <input
              type="text"
              className={`form-control ${
                errors.destinationLocationName ? "is-invalid" : ""
              }`}
              value={formData.destinationLocationName}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  destinationLocationName: e.target.value,
                }))
              }
              required
            />
          </Autocomplete>
          {errors.destinationLocationName && (
            <div className="invalid-feedback">
              {errors.destinationLocationName}
            </div>
          )}
        </div>

        <div className="mb-3">
          <label className="form-label fw-bold">Distance (km)</label>
          <input
            type="text"
            className="form-control"
            value={formData.distance}
            readOnly
            style={{ backgroundColor: "#e9ecef" }}
          />
        </div>

        <div className="mb-3">
          <label className="form-label fw-bold">Charge (ETB)</label>
          <input
            type="text"
            className="form-control"
            value={formData.charge}
            readOnly
            style={{ backgroundColor: "#e9ecef" }}
          />
        </div>

        <div className="mb-3">
          <label className="form-label fw-bold">Pickup Time</label>
          <input
            type="datetime-local"
            className={`form-control ${errors.pickupTime ? "is-invalid" : ""}`}
            name="pickupTime"
            value={formData.pickupTime}
            onChange={handleChange}
            required
            min={new Date().toISOString().slice(0, 16)}
          />
          {errors.pickupTime && (
            <div className="invalid-feedback">{errors.pickupTime}</div>
          )}
        </div>

        <div className="mb-3">
          <label className="form-label fw-bold">Assign Driver</label>
          <input
            type="text"
            className={`form-control ${errors.driverId ? "is-invalid" : ""}`}
            name="driverId"
            value={formData.driverId}
            onChange={handleChange}
            required
          />
          {errors.driverId && (
            <div className="invalid-feedback">{errors.driverId}</div>
          )}
        </div>

        {errors.submit && (
          <div className="alert alert-danger">{errors.submit}</div>
        )}

        <button
          type="submit"
          className="btn btn-primary w-100"
          disabled={isSubmitting}
        >
          {isSubmitting ? "Booking..." : "Book Ride"}
        </button>
      </form>
    </div>
  );
};

export default AddSchedule;
